import styles from './index.module.css'
import cn from 'clsx'

import React from 'react'
import type { PopoverItemType } from 'types/ui'
import { formatRelativeDate } from '@disco/utils/time-utils'
type ActionProps = {
  id: number
  name: string
  status: string
  onRemove: (id: number, name: string) => Promise<void>
  onResendInvite: (name: string) => Promise<void>
}
export const shareActionOptions = (props: ActionProps): PopoverItemType[] => {
  const { id, name, status, onRemove, onResendInvite } = props
  let actions: PopoverItemType[] = [
    {
      label: 'Remove',
      onClick: () => onRemove(id, name),
      destructive: true,
    },
  ]
  if (status === 'pending')
    actions = [
      {
        label: 'Resend',
        onClick: () => onResendInvite(name),
      },
      ...actions,
    ]
  return actions
}
export const renderShareLastActivity = (
  last_activity: string | null,
): React.ReactNode => {
  if (!last_activity) return <span>-</span>
  return <span>{formatRelativeDate(last_activity)}</span>
}
export const renderShareStatus = (status: string): React.ReactNode => {
  const statusConfig = {
    accepted: {
      displayName: 'ACCESSED',
      displayBadge: styles.SharedDiscoStatus_Badge__Accessed,
    },
    pending: {
      displayName: 'PENDING',
      displayBadge: styles.SharedDiscoStatus_Badge__Pending,
    },
    left: {
      displayName: 'LEFT',
      displayBadge: styles.SharedDiscoStatus_Badge__Left,
    },
  }
  return (
    <div
      className={cn(
        styles.SharedDiscoStatus_Badge,
        statusConfig[status].displayBadge,
      )}
    >
      {statusConfig[status].displayName}
    </div>
  )
}
